<template>
  <div>
    <form onsubmit="return false">
      <div style="margin-bottom: 15px;">
        <label for="eersteregistratie" style="font-weight: bold; text-transform: uppercase; font-size: 18px; display: block;">Eerste registratie</label>
        <select v-model.number="registrationYear" id="eersteregistratie" style="font-size: 15px; display: inline-block; line-height: 1.6em; padding: .6rem 1rem; margin-right: 5px; width: 100px;">
          <option v-for="year in rangeDesc(maxYear, minYear)" v-bind:key="year" :value="year">{{ year }}</option>
        </select>
        <select v-model.number="registrationMonth" style="font-size: 15px; display: inline-block; line-height: 1.6em; padding: .6rem 1rem; width: 100px;">
          <option v-for="month in rangeAsc(minMonth, maxMonth)" v-bind:key="month" :value="month">{{ month }}</option>
        </select>
      </div>
      <div style="display: grid; grid-template-columns: 45% 45%; gap: 10px;">
        <div style="margin-bottom: 15px;">
          <label for="Brandstof" style="font-weight: bold; text-transform: uppercase; font-size: 18px; display: block;">Brandstof</label>
          <select v-model.number="fuelType" id="brandstof" style="height: 44px; font-size: 15px; display: block; line-height: 1.6em; padding: .6rem 1rem; width: 100%;">
            <option v-for="(fuelType, value) in fuelTypes" v-bind:key="value" :value="value">{{  fuelType }}</option>
          </select>
        </div>
        <div style="margin-bottom: 15px;" v-if="co2Error">
            <label for="co2" style="font-weight: bold; text-transform: uppercase; font-size: 18px; display: block; color: red;">Co2 uitstoot</label>
            <input type="text" v-model.number="co2Emission" style="display: inline; font-size: 15px; line-height: 1.6em; padding: .5rem 1rem; width: 100%; border-color: red;">
            <small style="color: red;">Co2 uitstoot moet groter zijn dan 0</small>
        </div>
        <div style="margin-bottom: 15px;" v-else>
            <label for="co2" style="font-weight: bold; text-transform: uppercase; font-size: 18px; display: block;">Co2 uitstoot</label>
            <input type="text" v-model.number="co2Emission" style="display: inline; font-size: 15px; line-height: 1.6em; padding: .5rem 1rem; width: 100%;">
        </div>
        <div></div>
      </div>
      <div style="margin-bottom: 15px;">
        <button
            id="button"
            name="button"
            style="padding: 15px 50px; background-color: #3AAA35; border-width: 2px; border-color: #3AAA35; border-radius: 10px; text-transform: uppercase; font-size: 13px; color: white; border-style: solid;"
            v-on:click.prevent="calculate"
        >BPM berekenen</button>
      </div>
    </form>
    <br>
    <div style="color: #3AAA35; text-transform: uppercase; font-weight: 700; line-height: 1.2em;">
      <h3 style="font-size: 23px;">Te betalen BPM:</h3>
      <p style="font-size: 21px; line-height: 1.2em;">
          €
        {{ showBpm }}<span v-if="showBpm !== null">,00</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BpmCalculator',
  data() {
    return {
      registrationYear: null,
      registrationMonth: 1,
      fuelType: 'B',
      co2Emission: null,
      showBpm: null,
      co2Error: false

    }
  },
  mounted() {
    this.registrationYear = this.maxYear
    this.registrationMonth = 1
  },
  watch: {
    registrationDate() {
      this.registrationDateDate = new Date(this.registrationDate)
    },
    co2Emission() {
      this.co2Error = false
    },
    registrationYear() {
      if (this.registrationMonth > this.maxMonth) {
        this.registrationMonth = 1
      }
      if (this.registrationMonth < this.minMonth) {
        this.registrationMonth = this.minMonth
      }
      if (this.registrationYear < 2017) {
        if ((this.fuelType === 'HB') || (this.fuelType === 'HD') || (this.fuelType === 'E')) {
          this.fuelType = 'B'
        }
      }
    }
  },
  computed: {
    fuelTypes() {
      if (this.registrationYear < 2017) {
        return {
          'B': 'Benzine',
          'D': 'Diesel',
          'L': 'LPG',
          'A': 'Aardgas',
        }
      } else {
        return {
          'B': 'Benzine',
          'D': 'Diesel',
          'HB': 'Hybride benzine',
          'HD': 'Hybride diesel',
          'L': 'LPG',
          'A': 'Aardgas',
          'E': 'Elektrisch',
        }
      }
    },
    maxYear() {
      var now = new Date()

      return now.getFullYear()
    },
    minYear() {
      return 2013
    },
    minMonth() {
      return 1
    },
    maxMonth() {
      return 12
    },
    calculatedBpm() {
      switch (this.fuelType) {
        case 'B':
        case 'L':
        case 'A':
          return this.benzine()
        case 'D':
          return this.diesel()
        case 'HB':
          return this.hybrideBenzine()
        case 'HD':
          return this.hybrideDiesel()
        case 'E':
          return this.elektrisch()
        default:
          return 0
      }
    },
    bpm() {
      switch (this.fuelType) {
        case 'B':
        case 'D':
        case 'L':
        case 'A':
          return this.bpmBD
        case 'HB':
        case 'HD':
          return this.bpmH
        case 'E':
          return 0
        default:
          return 0
      }
    },
    diffInMonths() {
      var now = new Date()
      var nowYear = now.getFullYear()
      var nowMonth = now.getMonth() + 1

      if (nowYear === this.registrationYear) {
        if (this.registrationMonth > nowMonth) {
          return 0
        }
        return nowMonth - this.registrationMonth
      } else if ((this.registrationYear === (nowYear - 1)) && (this.registrationMonth > nowMonth)) {
        return (12 - this.registrationMonth) + nowMonth
      } else {
        var diffYears = nowYear - this.registrationYear

        return (diffYears * 12) + nowMonth - this.registrationMonth
      }
    },
    bpmBD() {
      var staffels, base, multiplier

      if (this.registrationYear === 2013) {
        if (this.fuelType === 'D') {
          staffels = [88, 131, 192, 215]
          base = [0, 0, 5375, 14403, 20751]
          multiplier = [0, 125, 148, 276, 551]
        } else {
          staffels = [95, 140, 208, 229]
          base = [0, 0, 5625, 15689, 21485]
          multiplier = [0, 125, 148, 276, 551]
        }
      } else if (this.registrationYear === 2014) {
        if (this.fuelType === 'D') {
          staffels = [85, 120, 175, 197]
          base = [0, 0, 3675, 10605, 15819]
          multiplier = [0, 105, 126, 237, 474]
        } else {
          staffels = [88, 124, 182, 203]
          base = [0, 0, 3780, 11088, 16065]
          multiplier = [0, 125, 148, 276, 551]
        }
      } else if (this.registrationYear === 2015) {
        staffels = [82, 110, 160, 180]
        base = [175, 667, 2599, 8199, 12539]
        multiplier = [6, 69, 112, 217, 434]
      } else if (this.registrationYear === 2016) {
        staffels = [79, 106, 155, 174]
        base = [175, 649, 2512, 8588, 13129]
        multiplier = [6, 69, 124, 239, 478]
      } else if (this.registrationYear === 2017) {
        staffels = [76, 102, 150, 168]
        base = [353, 505, 2221, 9181, 13465]
        multiplier = [2, 66, 145, 238, 475]
      } else if (this.registrationYear === 2018) {
        staffels = [73, 98, 144, 162]
        base = [356, 502, 2077, 8471, 12593]
        multiplier = [2, 63, 139, 229, 458]
      } else if (this.registrationYear === 2019) {
        staffels = [71, 95, 139, 156]
        base = [360, 502, 1942, 7706, 11361]
        multiplier = [2, 60, 131, 215, 429]
      } else if (this.registrationYear === 2020) {
        if (this.registrationMonth < 7) {
          staffels = [68, 91, 133, 150]
          base = [366, 502, 1859, 7277, 10881]
          multiplier = [2, 59, 129, 212, 424]
        } else {
          staffels = [90, 116, 162, 180]
          base = [366, 456, 1938, 7642, 11314]
          multiplier = [1, 57, 124, 204, 408]

        }
      } else if (this.registrationYear === 2021) {
        staffels = [86, 111, 155, 172]
        base = [372, 458, 1958, 7766, 11438]
        multiplier = [1, 60, 132, 216, 432]
      } else if (this.registrationYear === 2022) {
        staffels    = [84, 109, 152, 168]
        base        = [376, 460, 2010, 7901, 11485]
        multiplier  = [1, 62, 137, 224, 448]
      } else if (this.registrationYear === 2023) {
        staffels    = [82, 106, 148, 165]
        base        = [400, 564, 2196, 8454, 12602]
        multiplier  = [2, 68, 149, 244, 488]
      } else if (this.registrationYear === 2024) {
        staffels    = [80, 104, 145, 161]
        base        = [400, 600, 2424, 9271, 13655]
        multiplier  = [2, 76, 167, 274, 549]
      } else if (this.registrationYear === 2025) {
        staffels    = [79, 101, 141, 157]
        base        = [667, 825, 2563, 9483, 14027]
        multiplier  = [2, 79, 173, 284, 568]
      }

      if (staffels) {
        // console.log('base', base)
        // console.log('co2Emission', this.co2Emission)
        // console.log('multiplier', multiplier)
        // console.log('staffels', staffels)

        if (this.co2Emission < staffels[0]) {
          return base[0] + (this.co2Emission * multiplier[0])
        } else if (this.co2Emission < staffels[1]) {
          return base[1] + ((this.co2Emission - staffels[0]) * multiplier[1])
        } else if (this.co2Emission < staffels[2]) {
          return base[2] + ((this.co2Emission - staffels[1]) * multiplier[2])
        } else if (this.co2Emission < staffels[3]) {
          return base[3] + ((this.co2Emission - staffels[2]) * multiplier[3])
        } else {
          return base[4] + ((this.co2Emission - staffels[3]) * multiplier[4])
        }
      }
      return 0

    },
    bpmH() {
      var staffels = [30, 50]
      var base
      var multiplier

      if (this.registrationYear === 2017) {
        base = [0, 600, 2400]
        multiplier = [20, 90, 300]
      } else if (this.registrationYear === 2018) {
        base = [0, 570, 2310]
        multiplier = [19, 87, 289]
      } else if (this.registrationYear === 2019) {
        base = [0, 810, 3070]
        multiplier = [27, 113, 271]
      } else if (this.registrationYear === 2020) {
        if (this.registrationMonth < 7) {
          base = [0, 810, 3030]
          multiplier = [27, 111, 267]
        } else {
          staffels = [34, 60]
          base = [0, 816, 2974]
          multiplier = [24, 83, 199]
        }
      } else if (this.registrationYear === 2021) {
        staffels = [34, 60]
        base = [0, 816, 3000]
        multiplier = [24, 84, 202]
      } else if (this.registrationYear === 2022) {
        staffels = [34, 60]
        base = [0, 816, 3026]
        multiplier = [24, 85, 204]
      } else if (this.registrationYear === 2023) {
        staffels = [34, 60]
        base = [0, 884, 3250]
        multiplier = [26, 91, 217]
      } else if (this.registrationYear === 2024) {
        staffels = [34, 60]
        base = [0, 952, 3552]
        multiplier = [28, 100, 239]
      } else if (this.registrationYear === 2025) {
        staffels = [34, 60]
        base = [0, 816, 3026]
        multiplier = [24, 85, 204]
      }

      if (this.co2Emission < staffels[0]) {
        return base[0] + (this.co2Emission * multiplier[0])
      } else if (this.co2Emission < staffels[1]) {
        return base[1] + ((this.co2Emission - staffels[0]) * multiplier[1])
      } else {
        return base[2] + ((this.co2Emission - staffels[1]) * multiplier[2])
      }
    },
    dieselToeslag() {
      var dieselToeslagPerGrCo2 = 0
      var minStaffel = 0

      if (this.registrationYear < 2013) {
        dieselToeslagPerGrCo2 = 0
      } else if (this.registrationYear === 2013) {
        dieselToeslagPerGrCo2 = 56.13
        minStaffel = 70
      } else if (this.registrationYear === 2014) {
        dieselToeslagPerGrCo2 = 72.93
        minStaffel = 70
      } else if (this.registrationYear === 2015) {
        dieselToeslagPerGrCo2 = 86
        minStaffel = 70
      } else if (this.registrationYear === 2016) {
        dieselToeslagPerGrCo2 = 86.43
        minStaffel = 67
      } else if (this.registrationYear === 2017) {
        dieselToeslagPerGrCo2 = 86.69
        minStaffel = 65
      } else if (this.registrationYear === 2018) {
        dieselToeslagPerGrCo2 = 87.38
        minStaffel = 63
      } else if (this.registrationYear === 2019) {
        dieselToeslagPerGrCo2 = 88.43
        minStaffel = 61
      } else if (this.registrationYear === 2020) {
        if (this.registrationMonth < 7) {
          dieselToeslagPerGrCo2 = 89.85
          minStaffel = 59
        } else {
          dieselToeslagPerGrCo2 = 78.82
          minStaffel = 80
        }
      } else if (this.registrationYear === 2021) {
        dieselToeslagPerGrCo2 = 83.59
        minStaffel = 77
      } else if (this.registrationYear === 2022) {
        dieselToeslagPerGrCo2 = 86.67
        minStaffel = 75
      } else if (this.registrationYear === 2023) {
        dieselToeslagPerGrCo2 = 94.3
        minStaffel = 73
      } else if (this.registrationYear === 2024) {
        dieselToeslagPerGrCo2 = 106.07
        minStaffel = 71
      } else if (this.registrationYear === 2025) {
        dieselToeslagPerGrCo2 = 109.87
        minStaffel = 70
      }

      if ((this.co2Emission > minStaffel) && (dieselToeslagPerGrCo2 > 0) && ((this.fuelType === 'D') || (this.fuelType === 'HD'))) {
        return (this.co2Emission - minStaffel) * dieselToeslagPerGrCo2
      }
      return 0
    },
    afschrijvingFactor() {
      var percentage = 0
      
      if (this.diffInMonths < 3) {
        percentage = 8 + ((this.diffInMonths) * 3)
      } else if (this.diffInMonths < 5) {
        percentage = 14 + ((this.diffInMonths - 2) * 2.5)
      } else if (this.diffInMonths < 9) {
        percentage = 19 + ((this.diffInMonths - 4) * 2.25)
      } else if (this.diffInMonths < 18) {
        percentage = 28 + ((this.diffInMonths - 8) * 1.444)
      } else if (this.diffInMonths < 30) {
        percentage = 41 + ((this.diffInMonths - 17) * 0.917)
      } else if (this.diffInMonths < 42) {
        percentage = 52 + ((this.diffInMonths - 29) * 0.833)
      } else if (this.diffInMonths < 54) {
        percentage = 62 + ((this.diffInMonths - 41) * 0.75)
      } else if (this.diffInMonths < 66) {
        percentage = 71 + ((this.diffInMonths - 53) * 0.416)
      } else if (this.diffInMonths < 78) {
        percentage = 76 + ((this.diffInMonths - 65) * 0.416)
      } else if (this.diffInMonths < 90) {
        percentage = 81 + ((this.diffInMonths - 77) * 0.333)
      } else if (this.diffInMonths < 102) {
        percentage = 85 + ((this.diffInMonths - 89) * 0.333)
      } else if (this.diffInMonths < 114) {
        percentage = 89 + ((this.diffInMonths - 101) * 0.25)
      } else {
        percentage = 92 + ((this.diffInMonths - 113) * 0.083)
        percentage = percentage > 100 ? 100 : percentage
      }

      return percentage / 100
    }
  },
  methods: {
    calculate() {
      this.co2Error = false
      if (this.co2Emission) {
        this.showBpm = Math.round(this.calculatedBpm)
      } else {
        this.co2Error = true
      }
    },
    benzine() {
      console.log('afschrijvingFactor', this.afschrijvingFactor)
      console.log('bpm', this.bpmBD)

      return (1 - this.afschrijvingFactor) * (this.bpmBD)
    },
    diesel() {
      console.log('afschrijvingFactor', this.afschrijvingFactor)
      console.log('bpm', this.bpmBD)
      console.log('dieselToeslag', this.dieselToeslag)

      return (1 - this.afschrijvingFactor) * (this.bpmBD + this.dieselToeslag)
    },
    hybrideBenzine() {
      console.log('afschrijvingFactor', this.afschrijvingFactor)
      console.log('bpm', this.bpmH)

      return (1 - this.afschrijvingFactor) * (this.bpmH)
    },
    hybrideDiesel() {
      console.log('afschrijvingFactor', this.afschrijvingFactor)
      console.log('bpm', this.bpmH)
      console.log('dieselToeslag', this.dieselToeslag)

      return (1 - this.afschrijvingFactor) * (this.bpmH  + this.dieselToeslag)
    },
    elektrisch() {
      return 0;
    },
    rangeDesc: function(min,max){
      var array = [], j = 0
      for(var i = min; i >= max; i--){
        array[j] = i;
        j++;
      }
      return array;
    },
    rangeAsc: function(min,max){
      var array = [], j = 0
      for(var i = min; i <= max; i++){
        array[j] = i;
        j++;
      }
      return array;
    },
  }
}
</script>

